module.exports = __webpack_public_path__ + "img/food_14.e42c20ac.jpg";